import axios from 'axios'
import constants from '../constants'
import { ReassignRoomPayload, Room, WaterlineInventoryResponse, WaterlineItem, WaterlineMetadata, WaterlineTestResult } from '../views/practice/waterline/types'
import { mapWaterlineInventoryToItem } from '../views/practice/waterline/utils'

export const addInOfficeWaterlineTestResult = async (customerNumber: string, testResult: Partial<WaterlineTestResult>) => {
  const { data } = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-results/in-office`, testResult);

  return data;
};

export const addWaterlineRoom = async (customerNumber: string, room: Room) => {
  const { data } = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-rooms`, room);

  return data;
};

export const deleteInOfficeWaterlineTestResult = async (customerNumber: string, testResultId: number) => {
  const { data } = await axios.delete(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-results/in-office/${testResultId}`);

  return data;
};

export const deleteWaterlineRoom = async (customerNumber: string, roomId: number) => {
  const { data } = await axios.delete(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-rooms/${roomId}`);

  return data;
};

export const getWaterlineInventory = async (customerNumber: string): Promise<WaterlineItem[]> => {
  const { data } = await axios.get<WaterlineInventoryResponse[]>(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-inventory`);

  return data.map((item) => mapWaterlineInventoryToItem(item));
};

export const getWaterlineRooms = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-rooms`);
  const rooms: Room[] = response.data

  return rooms
}

export const getWaterlineTestResults = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-results`)
  const results: WaterlineTestResult[] = response.data

  return results
};

export const reassignRoomChair = async (customerNumber: string, testResults: ReassignRoomPayload[]) => {
  const { data } = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-results/reassign-room-chair`, testResults);

  return data;
};

export const updateInOfficeWaterlineTestResult = async (customerNumber: string, testResult: Partial<WaterlineTestResult>) => {
  const { data } = await axios.put(
    `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-results/in-office/${testResult.test_result_id}`,
    testResult
  );

  return data;
};

export const updateWaterlineInventory = async (customerNumber: string, inventory: WaterlineItem) => {
  const { data } = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-inventory/${inventory.id}`, inventory);

  return data;
};

export const updateWaterlineRoom = async (customerNumber: string, room: Room) => {
  const { data } = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-rooms/${room.room_id}`, room);

  return data;
};

export const markWaterlineTestResultAsAddressed = async (customerNumber: string, testResult: WaterlineTestResult) => {
  const { data } = await axios.put(
    `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-results/mark-as-addressed/${testResult.test_result_id}`,
    testResult
  );

  return data;
}

export const updateWaterlineMetadata = async (customerNumber: string, metadata: WaterlineMetadata) => {
  await axios.patch(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-metadata`, metadata)
}
